<template>
  <div
    class="accent-card"
    :class="cardClass"
  >
    <LazyloadPlaceholder class="accent-card__placeholder" />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import LazyloadPlaceholder from '~/components/LazyloadPlaceholder.vue';
  export default defineNuxtComponent({
    name: 'AccentCardPlaceholder',
    components: {
      LazyloadPlaceholder,
    },

    props: {
      size: {
        type: String as PropType<string>,
        default: 'small',
      },

      insideTv: {
        type: Boolean as PropType<boolean>,
        default: false,
      },
    },

    computed: {
      cardClass(): object {
        return {
          [`accent-card--${this.size}`]: this.size,
          'accent-card--big-inside-tv': this.size === 'big' && this.insideTv,
        };
      },
    },
  });
</script>

<style lang="scss" scoped>
  .accent-card {
    border-radius: 32px;
    background: #fff;
    position: relative;
    height: 360px;
    width: 100%;
    &__placeholder {
      border-radius: 32px;
    }
    &--small {
      max-width: 368px;
      max-height: 360px;
      @include tablet {
        height: 440px;
        max-height: none;
      }

      @include big-tablet {
        height: 480px;
      }
    }

    &--middle {
      @include tablet {
        height: 378px;
      }
    }
  }
  .accent-card--big-inside-tv {
    max-width: 748px;
  }
</style>
